import { Grid, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Authorize from 'components/Authorize';
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import DataTable from "components/DataTable/DataTable";
import { activityStatusById, activityStatuses, activityStatusesList, completeStatuses, isVendorEditLocked } from "features/activity/activityConsts";
import { useGetAllActivityItemsQuery, useGetAllActivityTypesQuery, useGetMechanicalActivitiesQuery } from "features/activity/activitySlice";
import { useGetAllAliasesQuery } from 'features/activity/activityStatusAliasSlice';
import ActivityStatusAliasView from 'features/activityStatusAlias/ActivityStatusAliasView';
import { useGetClientsQuery } from "features/clients/clientSlice";
import { FlagEntityTypes } from 'features/flag/flagsConsts';
import { useGetLotsQuery } from "features/lots/lotSlice";
import NotesTooltip from "features/notes/NotesTooltip";
import HotNoteCell from "features/mechanicalWork/components/HotNotePanel/HotNoteCell";
import { NoteEntityTypes } from "features/notes/notesConsts";
import { useGetAllActivityLogNotesQuery } from "features/notes/notesSlice";
import { useGetVendorsQuery } from 'features/vendor/vendorSlice';
import { selectIsClient, selectIsVendor, selectUserClientAccountId, selectUserClientId, userHasOneClient } from "features/user/userSlice";
import ApprovePendingApprovalActivity from "features/vehicles/Activities/ApproveActivity";
import ApprovePendingInvoiceActivity from "features/vehicles/Activities/ApproveActivity/ApprovePendingInvoiceActivity";
import { FlagAsset } from 'features/vehicles/Flags/FlagAsset';
import EditActivityLog from 'features/vehicles/VehicleDetailsPage/EditActivityLog/EditActivityLog';
import VendorDetachedEmailDialog from 'features/vms/vendorDirectory/vendorDetachedTemplate/VendorDetachedEmailDialog';
import useSortOptions from "hooks/useSortOptions";
import { IconEdit } from 'icons';
import { IconActivityDefault } from 'icons/mechanicals';
import _, { groupBy, orderBy } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import FilterService, { fieldTypes } from "services/filterService";
import FormatService from 'services/formatService';
import { arrayToObject } from "utils/object-util";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import { userHasOneClientAccount, selectIsLoggedIn } from '../../../../user/userSlice';
import ActivityListConfirmContainer from './ActivityListConfirmContainer';
import ActivityListTabs, { getActivityListTabsList } from './ActivityListTabs';
import { ActivityPriceError } from "./ActivityPriceError";
import { ActivityStatus } from './ActivityStatus';
import BulkUpdateActivity from './BulkUpdateActivity';
import TimeInStatusBadge from './TimeInStatusBadge';
import { timeInStatusTiers, timeInStatusTierLabels } from './timeInStatusConsts';
import { activityTableStyle } from './style';
import AssetSearchBar from '../../../../../components/AssetSearchBar/AssetSearchBar';
import LoadsPage from 'features/loads/components/LoadsPage';
import AttachmentsTooltip from 'features/attachments/AttachmentsTooltip';
import { useGetAllActivityAttachmentsQuery } from 'features/attachments/attachmentSlice';
import { AttachmentEntityTypes } from "features/attachments/attachmentsConsts";
import { userPreferencesComponentIds } from 'components/UserPreferences/userPreferencesConsts';

const ActivityListTable = ({
    status,
    clientAccountId,
    clientId,
    lotId,
    month,
    allowActions = true,
    infoTextOnTable,
    additionalFilters = {},
    activities,
    title = 'Activities',
    pendingLoads,
    showActivityList = true,
    showWorkRequest = false
}) => {
    const classes = activityTableStyle()
    const history = useHistory();

    const isClient = useSelector(selectIsClient);
    const isVendor = useSelector(selectIsVendor);
    const userName = useSelector(state => state?.user?.userProfile?.name || '');
    let userClientId = useSelector(selectUserClientId);
    let userClientAccountId = useSelector(selectUserClientAccountId);
    const hasOneAccount = useSelector(userHasOneClientAccount);
    const isUserLoaded = useSelector(selectIsLoggedIn);

    let hasOneClaim = useSelector(userHasOneClient);

    let { data: mechanicalActivities, error: mechanicalActivitiesError, isFetching: isLoadingMechanicalActivities } = useGetMechanicalActivitiesQuery(undefined, { skip: activities != undefined || !showActivityList });
    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery();
    let { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();
    let { data: activityTypes, error: activityTypesError, isFetching: isLoadingActivityTypes } = useGetAllActivityTypesQuery();
    let { data: activityNotes, error: activityNotesError, isFetching: isLoadingNotes, refetch: getNotes } = useGetAllActivityLogNotesQuery();
    let { data: vendors, isLoading: isLoadingVendors } = useGetVendorsQuery();
    let { data: aliases, error: aliasError, isLoading: isLoadingAlias } = useGetAllAliasesQuery();
    let { data: activityAttachments } = useGetAllActivityAttachmentsQuery();

    const noteLookup = groupBy(activityNotes?.filter(n => n.workOrderId != null && !n.isHotNote), 'workOrderId');
    const attachmentLookup = groupBy(activityAttachments, 'entityId');

    const clientAccounts = _.flatten(clients?.map(c => c.clientAccounts));
    const activitiesData = activities ?? mechanicalActivities ?? [];

    const getClientId = (accId) => {
        return clientAccounts?.find(a => a.id == accId)?.clientId
    }
    let defaultFilters = {
        activityStatus: { value: status },
        openNonAutomatedStr: undefined,
        hasWorkRequestStr: undefined,
        ...additionalFilters
    };

    clientAccountId && (defaultFilters.clientAccountId = { value: [clientAccountId] })
    clientId && (defaultFilters.clientId = { value: [clientId] })
    !!lotId?.length && (defaultFilters.lotId = { value: lotId })
    month && (defaultFilters.activityMonth = { value: month })

    const [sortOptions, sortData] = useSortOptions();
    const [search, setSearch] = useState('');
    const [assets, setAssets] = useState([]);
    const [woRoTerms, setWoRoTerms] = useState([]);
    const [wrTerms, setWrTerms] = useState([]);
    const [activityLogToEdit, setActivityLogToEdit] = useState();
    const [vendorEmailDraft, setVendorEmailDraft] = useState(null);
    const [vendorEmailWorkOrderId, setVendorEmailWorkOrderId] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0);

    const [filters, setFilters] = useState(defaultFilters);

    useEffect(() => {
        setFilters(defaultFilters);
    }, [clientAccountId, clientId, lotId, month]);

    const canSeeFlags = isAuthorized(permissionProfiles.FLAGS.VIEW_FLAGS);
    const canSeeNotes = isAuthorized(permissionProfiles.NOTES.VIEW_NOTES);
    const canSeeAttachments = true;

    const canSeeCharge = isAuthorized(permissionProfiles.ACTIVITY.CHARGE_VIEW);
    const canSeeClientIdentity = isAuthorized(permissionProfiles.ACTIVITY.CLIENT_IDENTITY_VIEW);
    const canSeeCreatedBy = isAuthorized(permissionProfiles.ACTIVITY.AUDIT_IDENTITY_VIEW);
    const canSeeApprovalMeta = isAuthorized(permissionProfiles.ACTIVITY.APPROVAL_META_VIEW);
    const canLinkAssetDetail = isAuthorized(permissionProfiles.ACTIVITY.ASSET_DETAIL_LINK);

    useEffect(() => {
        const searchedVin = new URLSearchParams(window.location.search).get('vin');
        if (searchedVin) {
            setSearch(searchedVin);
            setFilters(defaultFilters);
        }
    }, [window.location.search])

    let presentClientAccountId = hasOneAccount ? parseInt(userClientAccountId?.[0]) : defaultFilters?.clientAccountId?.value ? parseInt(defaultFilters?.clientAccountId?.value) : filters?.clientAccountId?.value;
    useEffect(() => {
        presentClientAccountId = hasOneAccount ? parseInt(userClientAccountId?.[0]) : defaultFilters?.clientAccountId?.value ? parseInt(defaultFilters?.clientAccountId?.value) : filters?.clientAccountId?.value;
    }, [userClientAccountId, defaultFilters, filters])


    let filterConfig = [
        ...(hasOneClaim || !canSeeClientIdentity ? [] : [
            {
                type: fieldTypes.TEXT, size: 2, title: 'Client', key: 'clientId', values: clientAccounts?.filter(c => c.isDefault)?.map(acc => ({
                    id: acc?.clientId,
                    name: acc?.name
                }))
            }]),
        lots?.length
            ? { type: fieldTypes.LOT, size: 2, title: 'Lot', key: 'lotId', values: lots, multiple: true }
            : { type: fieldTypes.LIST, size: 2, title: 'Lot', key: 'lotId', values: [...new Map(activitiesData.filter(a => a.lotId).map(a => [a.lotId, { id: a.lotId, name: a.lotName }])).values()] },
        { type: fieldTypes.DATERANGE, size: 2, title: 'Time Frame', key: 'activityDate', values: [] },
        { type: fieldTypes.DATERANGE, size: 2, title: 'Due Date', key: 'requestedCompletionDate', values: [] },
        { type: fieldTypes.ACTIVITY_TYPE, size: 2, title: 'Activity Type', key: 'activityItemId', values: activityItems },
        {
            type: fieldTypes.TEXT, size: 2, title: 'Status', key: 'activityStatus', values: activityStatusesList.map(status => ({
                id: status.id,
                name: aliases?.find(a => a.activityStatusId === status.id && (a.clientAccountId === presentClientAccountId))?.alias ?? status.name
            }))
        },
        ...(!vendors?.length && isClient ? [] : [{ type: fieldTypes.TEXT, size: 2, title: 'Vendor', key: 'vendorId', values: vendors }]),
        ...(canSeeCreatedBy ? [{ type: fieldTypes.TEXT, size: 2, title: 'Created By External User', key: 'externalUser', values: [{ id: 'Yes', name: 'Yes' }, { id: 'No', name: 'No' }] }] : []),
        { type: fieldTypes.TEXT, size: 2, title: 'Hot Note', key: 'hotNoteStatus', values: [{ id: 'present', name: 'Has Hot Note' }, { id: 'absent', name: 'No Hot Note' }] },
        ...(canSeeApprovalMeta ? [
            {
                type: fieldTypes.TEXT, size: 2, title: 'L1 Approver', key: 'l1ApproverName',
                values: [
                    ...(userName ? [{ id: '__me__', name: 'Approvals by me', filterOn: 'l1ApproverName', filterOnValue: userName, pinTop: true }] : []),
                    { id: '__missing__', name: 'Missing L1 Approver', filterOn: 'l1ApproverStatus', filterOnValue: 'missing', pinTop: true },
                    ...[...new Set(activitiesData.map(a => a.l1ApproverName).filter(Boolean))].map(name => ({ id: name, name })),
                ]
            },
            {
                type: fieldTypes.TEXT, size: 2, title: 'L2 Approver', key: 'l2ApproverName',
                values: [
                    ...(userName ? [{ id: '__me__', name: 'Approvals by me', filterOn: 'l2ApproverName', filterOnValue: userName, pinTop: true }] : []),
                    { id: '__missing__', name: 'Missing L2 Approver', filterOn: 'l2ApproverStatus', filterOnValue: 'missing', pinTop: true },
                    ...[...new Set(activitiesData.map(a => a.l2ApproverName).filter(Boolean))].map(name => ({ id: name, name })),
                ]
            },
            { type: fieldTypes.NUMBERRANGE, size: 2, title: 'Approved Amount', key: 'l2ApprovalAmount', values: [] },
        ] : []),
        { type: fieldTypes.TEXT, size: 2, title: 'Open more than 30 days', key: 'openMoreThan30DaysStr', values: [{ id: 'Yes', name: 'Yes' }, { id: 'No', name: 'No' }] },
        { type: fieldTypes.LIST, size: 2, title: 'Open & Non-Automated', key: 'openNonAutomatedStr', values: [{ id: 'Yes', name: 'Open & Non-Automated' }] },
        ...(showWorkRequest ? [{ type: fieldTypes.LIST, size: 2, title: 'Work Requests', key: 'hasWorkRequestStr', values: [{ id: 'Yes', name: 'Work Requests' }] }] : []),
    ];

    if (canSeeFlags) {
        filterConfig.push({
            type: fieldTypes.TEXT,
            size: 2,
            title: 'Flagged',
            key: 'flaggedStr',
            values: [{ id: 'Yes', name: 'Yes' }, { id: 'No', name: 'No' }]
        });
    }

    let subClients = clientAccounts?.filter(a =>
        !a.isDefault &&
        (filters?.clientId && filters?.clientId?.value?.length > 0 ? filters?.clientId.value?.includes(a.clientId) : true)
    )

    if (canSeeClientIdentity && subClients?.length > 0) {
        filterConfig.splice(1, 0, {
            type: fieldTypes.TEXT,
            size: 2,
            title: 'Sub Client',
            key: 'clientAccountId',
            values: subClients,
            multiple: false
        });
    }

    const getStatusName = (activity) => {
        let name = aliases?.find(a => a.activityStatusId === activity.activityStatus && a.clientId === activity.clientId)?.alias ?? activityStatusById?.[activity.activityStatus]?.name;
        if (activity.activityStatus === activityStatuses.PendingApproval && activity.abovePriceCap) {
            name = `${name} (above price cap)`
        }
        return name;
    }

    const lotsLookup = useMemo(() => arrayToObject(lots), [lots]);
    const clientLookup = useMemo(() => arrayToObject(clients), [clients]);
    const activityItemsLookup = useMemo(() => arrayToObject(activityItems), [activityItems]);
    const activityTypesLookup = useMemo(() => arrayToObject(activityTypes), [activityTypes]);
    const vendorLookup = useMemo(() => arrayToObject(vendors), [vendors]);
    const clientAccountsLookup = useMemo(() => arrayToObject(clientAccounts), [clientAccounts]);
    const CALookupWithoutDefault = useMemo(() => arrayToObject(clientAccounts?.filter(c => c.isDefault == false)), [clientAccounts]);

    // const formatDates = (date, lotId) => {
    //     return For matService.formatDateNoConversion(lotsLookup?.[lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(date, lotsLookup?.[lotId]?.ianaTimeZone) : date)
    //     return date;
    // }

    const getIfExternalUser = (createdBy) => {
        if (createdBy?.includes('@') && !createdBy?.endsWith("@parkmyfleet.com") && !createdBy?.startsWith("pmftablet") && !createdBy?.startsWith("pmfpixel")) {
            return "Yes";
        } else { return "No"; }
    }

    const mappedData = useMemo(() => activitiesData?.map(activity => {
        var client = clientLookup?.[activity.clientId];
        var clientAccount = clientAccountsLookup[activity.clientAccountId];
        return {
            ...activity,
            activityItem: activityItemsLookup?.[activity.activityItemId]?.name,
            activityStatusAndName: { activityStatus: activity.activityStatus, activityStatusName: getStatusName(activity) },
            vehicle: { id: activity.vehicleId, descriptor: activity?.descriptor, assetId: activity?.assetId },
            vehicleIdentifer: `${activity.descriptor}$$${activity.assetId}`,
            client: client?.name,
            subClient: clientAccount ? activity.clientAccountId : null,
            clientName: client?.name + (client?.name != clientAccount?.name ? ": " + clientAccount?.name : ""),
            lot: lotsLookup?.[activity.lotId]?.name ?? activity.lotName,
            withinSlaStr: activity.withinSla ? 'Yes' : 'No',
            openNonAutomatedStr: (!completeStatuses.includes(activity.activityStatus) && activity.activityStatus !== activityStatuses.Cancelled && !activity.systemGenerated) ? 'Yes' : 'No',
            hasWorkRequestStr: activity.workRequestId ? 'Yes' : 'No',
            activityDateFormatted: FormatService.formatDateNoConversion(activity.activityDateFormatted),
            requestedCompletionDateFormatted: FormatService.formatDateNoConversion(activity.requestedCompletionDate),
            activityObj: activity,
            flaggedStr: activity?.latestFlag ? 'Yes' : 'No',
            vendor: vendorLookup?.[activity?.vendorId]?.name,
            externalUser: getIfExternalUser(activity?.createdBy),
            hotNoteStatus: activity?.hotNote ? 'present' : 'absent',
            l1ApproverStatus: activity?.l1ApproverName ? 'present' : 'missing',
            l2ApproverStatus: activity?.l2ApproverName ? 'present' : 'missing',
            openMoreThan30DaysStr: (activity.daysOpen > 30 && !completeStatuses.includes(activity.activityStatus) && activity.activityStatus !== activityStatuses.Cancelled) ? 'Yes' : 'No',
            timeInStatusSortValue: (activity.timeInStatusPercent != null && activity.timeInStatusTier !== timeInStatusTiers.NoThreshold) ? -activity.timeInStatusPercent : Number.MAX_SAFE_INTEGER,
        }
    }), [activitiesData]);


    const mapExportData = activity => {
        let allDataMap = {
            ...activity,
            ["Work Order Id"]: activity.workOrderId,
            Date: activity.activityDateFormatted,
            VIN: activity.descriptor,
            ["Asset Id"]: activity.assetId,
            Client: clientLookup?.[activity.clientId]?.name,
            ["Sub Client"]: CALookupWithoutDefault[activity.clientAccountId]?.name ?? "",
            Lot: lotsLookup?.[activity.lotId]?.name ?? activity.lotName,
            ["Type"]: activityTypesLookup?.[activity.activityTypeId]?.name,
            ["Activity"]: activityItemsLookup?.[activity.activityItemId]?.name,
            ["Status"]: getStatusName(activity),
            ["Within SLA"]: activity.withinSlaStr,
            "Charge": activity.revenue,
            ["Sub client"]: clientAccountsLookup[activity.clientAccountId]?.name ?? '',
            ["Created By"]: activity.createdBy,
            ["Description"]: activity.customActivity,
            ["Due Date"]: activity.requestedCompletionDateFormatted,
            ["Repair Order"]: activity.repairOrder
        }
        if (showWorkRequest) {
            allDataMap["Work Request Id"] = activity.workRequestId ?? '';
            allDataMap["External Work Request Id"] = activity.externalWorkRequestId ?? '';
        }
        if (vendors?.length)
            allDataMap["Vendor"] = vendorLookup?.[activity?.vendorId]?.name
        if (!isClient)
            allDataMap["Cost"] = activity.price;
        allDataMap['Hot Note'] = FormatService.sanitizeForCsv(activity.hotNote);
        allDataMap['L1 Approver'] = activity.l1ApproverName ?? '';
        allDataMap['L2 Approver'] = activity.l2ApproverName ?? '';
        allDataMap['Approved Amount'] = activity.l2ApprovalAmount ?? '';
        allDataMap['Last Activity'] = FormatService.formatDateNoConversion(activity.lastActivity);
        allDataMap['Days Open'] = activity.daysOpen ?? '';      
        allDataMap['Time in Status'] = timeInStatusTierLabels[activity.timeInStatusTier] ?? '';
        allDataMap['Notes'] = noteLookup[activity.workOrderId]?.map(n => FormatService.sanitizeForCsv(n.content))?.join(", ") ?? '';
        const attachmentCount = attachmentLookup[activity.id]?.length ?? 0;
        allDataMap['Attachments'] = attachmentCount ? `${attachmentCount} ${attachmentCount === 1 ? 'Attachment' : 'Attachments'}` : 'No Attachments';
        allDataMap['Charge'] = activity.revenue;
        return allDataMap;
    };

    const dataLookup = arrayToObject(mappedData);

    let activityColumns = [
        // { name: "Days completed in", key: "daysCompletedIn" },
        // { name: "Days to complete", key: "daysToComplete" },
        { name: "Work Order Id", key: "workOrderId" },
        ...(showWorkRequest ? [
            { name: "Work Request Id", key: "workRequestId" },
            { name: "External Work Request Id", key: "externalWorkRequestId", width: 300 },
        ] : []),
        { name: "Date", key: "activityDateFormatted" },
        { name: "Due Date", key: "requestedCompletionDateFormatted" },
        { name: "Type", key: "activityTypeId", values: activityTypes, selectedByDefault: true, width: 100 },
        { name: "Activity", key: "activityItemId", values: activityItems, selectedByDefault: true, component: (row) => <Link target='_blank' to={`/workorder/${row?.workOrderId}`} className={classes.link}>{row.activityItem}</Link> },
        { name: "VIN", key: "descriptor", width: 200, component: (row) => canLinkAssetDetail ? <Link target='_blank' to={`/assets/detail/${row?.vehicleId}`} className={classes.link}>{row?.descriptor}</Link> : <span>{row?.descriptor}</span> },
        { name: "Asset Id", key: "assetId", width: 200, component: (row) => canLinkAssetDetail ? <Link target='_blank' to={`/assets/detail/${row?.vehicleId}`} className={classes.link}>{row?.assetId}</Link> : <span>{row?.assetId}</span> },
        {
            name: "Status", key: "activityStatusAndName", component: (row) => <ActivityStatus
                activityStatus={row?.activityStatusAndName}
                clientId={Array.isArray(userClientId) && userClientId.length > 0
                    ? parseInt(userClientId[0])
                    : clientId || row?.clientId}
            />
        },
        {
            name: "Time in Status", key: "timeInStatusTier", sortKey: "timeInStatusSortValue", selectedByDefault: true, width: 200,
            component: (row) => <TimeInStatusBadge tier={row?.timeInStatusTier} />
        },
        ...(canSeeApprovalMeta ? [{ name: "L1 Approver", key: "l1ApproverName" }] : []),
        ...(canSeeApprovalMeta ? [{ name: "L2 Approver", key: "l2ApproverName" }] : []),
        { name: "Last Activity", key: "lastActivity", selectedByDefault: true, component: (row) => row.lastActivity ? FormatService.formatRelativeDate(row.lastActivity) : <span className={classes.emptyIndicator}>—</span> },
        { name: "Days Open", key: "daysOpen", selectedByDefault: true },
        { name: "Description", key: "customActivity", selectedByDefault: true },
        { name: "Repair Order", key: "repairOrder" },
        ...(hasOneClaim || !canSeeClientIdentity ? [] : [{ name: "Client", key: "client" }]),
        ...(canSeeClientIdentity ? [{ name: "Sub Client", key: "subClient", values: clientAccounts?.filter(a => a.isDefault == false), width: 200 }] : []),
        { name: "Lot", key: "lot" },
        ...(!vendors?.length && isClient ? [] : [{ name: "Vendor", key: "vendor" }]),
        ...(isClient ? [] : [{ name: "Cost", key: "price", component: (row) => FormatService.formatCurrency(row?.price) }]),
        ...(canSeeCharge ? [{ name: "Charge", key: "revenue", component: (row) => FormatService.formatCurrency(row?.revenue) }] : []),
        ...(canSeeApprovalMeta ? [{ name: "Approved Amount", key: "l2ApprovalAmount", component: (row) => row?.l2ApprovalAmount !== null && row?.l2ApprovalAmount !== undefined ? FormatService.formatCurrency(row?.l2ApprovalAmount) : '' }] : []),
        ...(canSeeCreatedBy ? [{ name: "Created By", key: "createdBy", width: 200 }] : []),
        {
            name: "Hot Note", key: "hotNote",
            component: (row) => <HotNoteCell activityId={row?.id} hotNote={row?.hotNote} />
        },
        { name: "Within SLA", key: "withinSlaStr" },
        ...(isClient ? [] : [{ name: "Alert", key: "activityObj", component: (activityObj) => <ActivityPriceError activity={activityObj} />, width: 50 }]),
    ];

    if (canSeeNotes) {
        activityColumns.unshift({
            name: "Notes",
            key: "notes",
            component: (row) => {
                return <NotesTooltip
                    entityId={row?.id}
                    entityType={NoteEntityTypes.ACTIVITY}
                    readOnly={isVendorEditLocked({ activityId: row?.activityStatus }, isVendor)}
                />
            }
        });
    }

    if (canSeeAttachments) {
        activityColumns.unshift({
            name: "Attachments",
            key: "Attachments",
            component: (row) => {
                const vendorLocked = isVendorEditLocked({ activityId: row?.activityStatus }, isVendor);
                return <AttachmentsTooltip
                    entityId={row?.id}
                    entityType={AttachmentEntityTypes.ACTIVITY}
                    allowAdd={!vendorLocked}
                    allowDelete={!vendorLocked}
                    notesReadOnly={vendorLocked}
                />
            }
        });
    }

    if (canSeeFlags) {
        activityColumns.unshift({
            name: '',
            key: 'latestFlag',
            width: 50,
            selectedByDefault: true,
            customizable: false,
            component: (row) => {
                return <FlagAsset
                    iconOnly
                    selectedRows={[row?.id]}
                    flagOn={dataLookup?.[row?.id]?.latestFlag}
                    flagObj={dataLookup?.[row?.id]?.latestFlag}
                    getFlagFromApi={false}
                    allData={mappedData}
                    entityType={FlagEntityTypes.ACTIVITY}
                />
            }
        });
    }

    let filteredData = FilterService.filter(filters, search, mappedData, filterConfig);
    let filterByVehicle = filteredData?.filter(activity => {
        if (assets?.length > 0 && !assets.some(a => a.id === activity?.vehicleId)) return false;
        if (wrTerms.length > 0) {
            const workRequestIds = [activity?.workRequestId, activity?.externalWorkRequestId]
                .filter(id => id !== null && id !== undefined)
                .map(id => String(id).toLowerCase());
            if (!wrTerms.some(term => workRequestIds.includes(term.trim().toLowerCase()))) return false;
        }
        if (woRoTerms.length > 0) {
            return woRoTerms.some(token =>
                Object.values(activity).some(val => {
                    if (typeof val === 'string') return val.toLowerCase().includes(token.toLowerCase());
                    if (typeof val === 'number') return String(val).includes(token);
                    return false;
                })
            );
        }
        return true;
    }) ?? [];

    let pendingActivitiesAndLoads = orderBy([...(showActivityList ? filterByVehicle : []), ...(pendingLoads ?? [])], ['createdDate'], ['asc']);

    const onDropFilter = (filterValue, prop) => {
        setFilters({ ...filters, [prop]: { value: filterValue } });
    };

    const onResetFilters = () => {
        setFilters(defaultFilters);
    };

    const onEdit = (rowId) => {
        setActivityLogToEdit(dataLookup?.[rowId]);
    };

    const onChangeTab = (tab) => {
        setSelectedTab(tab);
    }

    const updateAllFilters = (newFilters) => {
        setFilters(newFilters);
    };

    const isLoading = isLoadingLots || isLoadingClients || isLoadingActivityItems || isLoadingMechanicalActivities;

    const rowActions = (rowId) => {
        const row = mappedData?.find(activity => activity.id === rowId);
        const actions = [
            {
                icon: <IconActivityDefault width={24} />,
                label: 'View',
                // profile: permissionProfiles.ASSETS.EDIT_ACTIVITY,
                onClick: () => history.push(`/workorder/${row.workOrderId}`)
            },
            {
                icon: <IconEdit width={24} />,
                label: 'Edit',
                profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG,
                onClick: () => onEdit(rowId)
            }
        ];
        if (!allowActions) return actions;
        // if (row?.activityStatus == activityStatuses.PendingApproval) {
        //     actions.push(
        //         {
        //             label: '',
        //             component: <ApprovePendingApprovalActivity activityLog={row} />
        //         }
        //     );
        // }
        if (row?.activityStatus == activityStatuses.PendingInvoice) {
            actions.push(
                {
                    label: '',
                    component: <ApprovePendingInvoiceActivity selectedRows={[row?.id]} activityLogs={[row]} />
                }
            );
        }
        // if (row?.activityStatus == activityStatuses.RequestedByClient) {
        //     actions.push(
        //         {
        //             label: '',
        //             component: <UpdateActivityStatus selectedRows={[row?.id]} activityLogs={[row]} updateStatusTo={activityStatuses.InProgress} fromStatus={activityStatuses.RequestedByClient} />
        //         }
        //     );
        // }
        return actions;
    }

    const getRowClassName = (rowIndex) => {
        return (canSeeFlags && filterByVehicle?.[rowIndex]?.latestFlag) ? classes.flaggedRow : '';
    }

    const statusForDisplay = Array.isArray(filters?.activityStatus?.value) ? filters?.activityStatus?.value?.[0] : filters?.activityStatus?.value;
    const statusName = filters?.activityStatus?.value?.length ? <ActivityStatusAliasView activityIds={filters?.activityStatus?.value} clientId={getClientId(presentClientAccountId)} readonly={true} /> : title;

    const StatusHeader = () => {
        return (
            <div>
                <Grid container alignItems='center' spacing={1}>
                    <Grid item ><div className={`${classes.dot} ${classes?.[`activityTableCount${statusForDisplay}`] ?? classes?.activityTableCountAttention}`}></div></Grid>
                    <Grid item className={classes.title}>{statusName}</Grid>
                    <Grid item className={`${classes.activityTableCount} ${classes?.[`activityTableCount${statusForDisplay}`] ?? classes?.activityTableCountAttention}`}>
                        {pendingActivitiesAndLoads?.length}
                    </Grid>
                    {infoTextOnTable && <Grid item style={{ display: 'flex' }}> <Tooltip title={infoTextOnTable}><InfoOutlinedIcon /></Tooltip></Grid>}
                </Grid>
            </div>
        );
    }

    const activityListTabsList = getActivityListTabsList(showActivityList);

    return (
        <>
            <div className={classes.paper}>
                {
                    isLoading && <LoadingSpinner loading={isLoading} />}
                <Authorize profile={permissionProfiles.DASHBOARD.MECHANICAL_VIEW}>
                    {filters?.activityStatus?.value?.length == 1 && filters?.activityStatus?.value?.[0] == activityStatuses.PendingClientApproval ?
                        <Authorize profile={permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT && permissionProfiles.LOAD.LOAD_APPROVE_PRICE}>
                            <ActivityListTabs selectedTab={selectedTab} setSelectedTab={onChangeTab} showActivityList={showActivityList} />
                        </Authorize> : <></>
                    }
                    {selectedTab == activityListTabsList?.WorkOrdersPendingApproval ?
                        <div className={classes.table} >
                            <DataTable
                                tableId={userPreferencesComponentIds.ACTIVITY_LOG}
                                allowColumnCustomization
                                updateAllFilters={updateAllFilters}
                                title={StatusHeader()}
                                searchComponent={<AssetSearchBar
                                    assets={assets}
                                    setAssets={setAssets}
                                    assetsList={_.uniqBy(filteredData?.map(d => d?.vehicle), 'id')}
                                    onSearch={setSearch}
                                    searchVal={search}
                                    woRoTerms={woRoTerms}
                                    onWoRoTermsChange={setWoRoTerms}
                                    wrTerms={wrTerms}
                                    onWrTermsChange={showWorkRequest ? setWrTerms : undefined}
                                />}
                                dropDownsConfig={filterConfig}
                                filters={filters}
                                onDropFilter={onDropFilter}
                                onResetFilters={onResetFilters}
                                withFilterPanel
                                getRowClassName={getRowClassName}
                                columns={activityColumns}
                                rows={orderBy(
                                    filterByVehicle,
                                    sortOptions.columnToSort,
                                    sortOptions.columnToSort === 'lastActivity'
                                        ? (sortOptions.sortDirection === 'asc' ? 'desc' : 'asc')
                                        : sortOptions.sortDirection
                                )}
                                rowIdentifier='id'
                                onSort={sortData}
                                sortDirection={sortOptions.sortDirection}
                                columnToSort={sortOptions.columnToSort}
                                noItemsMessage='There are no activities matching this criteria'
                                actions={isClient ? undefined : rowActions}
                                showActionsInMenu
                                bulkActions={allowActions ? [
                                    ...(isAuthorized(permissionProfiles.ACTIVITY.PENDING_APPROVAL_ADD_PRICE) ? [<ApprovePendingInvoiceActivity bulk activityLogs={mappedData} />] : []),
                                    // ...((isAuthorized(permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG)) ?
                                    //     [<UpdateActivityStatus bulk activityLogs={mappedData} updateStatusTo={activityStatuses.PendingInvoice} fromStatus={activityStatuses.InProgress} />] : []),
                                    //Moving from requested by client -> in progress is incorrect
                                    //...((isAuthorized(permissionProfiles.ACTIVITY.ACTIVITY_MOVE_TO_NEXT_STATUS) && isAuthorized(permissionProfiles.ACTIVITY.PENDING_INVOICE_ADD_PRICE)) ? [<UpdateActivityStatus bulk activityLogs={mappedData} updateStatusTo={activityStatuses.InProgress} fromStatus={activityStatuses.RequestedByClient} />] : []),
                                    // ...(isAuthorized(permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT) ?
                                    //     [<UpdateActivityStatus bulk activityLogs={mappedData} updateStatusTo={activityStatuses.PricingApprovedByClient} fromStatus={activityStatuses.PendingClientApproval} />,
                                    //     <UpdateActivityStatus bulk activityLogs={mappedData} updateStatusTo={activityStatuses.Cancelled} fromStatus={activityStatuses.PendingClientApproval} />] : []),

                                    ...((isAuthorized(permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG)) ?
                                        [<BulkUpdateActivity activityLogs={mappedData} />]
                                        : []),
                                ] : undefined}
                                mapExportData={mapExportData}
                            />
                        </div>
                        : selectedTab == activityListTabsList.LoadsPendingApproval ?
                            <div className={classes.table} >
                                <LoadsPage loads={pendingLoads} />
                            </div>
                            : <Authorize profile={permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT && permissionProfiles.LOAD.LOAD_APPROVE_PRICE}>
                                <ActivityListConfirmContainer
                                    entities={pendingActivitiesAndLoads}
                                    title={StatusHeader()}
                                />
                            </Authorize>
                    }
                </Authorize>
                {
                    !!activityLogToEdit &&
                    <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG}>
                        <EditActivityLog
                            vehicleTypeId={activityLogToEdit?.vehicleTypeId}
                            clientId={activityLogToEdit?.clientId}
                            clientAccountId={activityLogToEdit?.subClient}
                            activityLog={{
                                ...activityLogToEdit,
                                activityLogId: activityLogToEdit?.id,
                                activityId: activityLogToEdit?.activityStatus,
                                date: activityLogToEdit?.activityDate,
                                cost: activityLogToEdit?.price
                            }}
                            onCancel={() => setActivityLogToEdit(null)}
                            onConfirm={(res) => {
                                const editedWorkOrderId = activityLogToEdit?.id;
                                setActivityLogToEdit(null);
                                if (res?.emailDraft) {
                                    setVendorEmailWorkOrderId(editedWorkOrderId);
                                    setVendorEmailDraft(res.emailDraft);
                                }
                            }}
                        />
                    </Authorize>
                }
                <VendorDetachedEmailDialog
                    open={!!vendorEmailDraft}
                    onClose={() => setVendorEmailDraft(null)}
                    emailDraft={vendorEmailDraft}
                    activityLogId={vendorEmailWorkOrderId}
                />
            </div >
        </>
    )
}

export default ActivityListTable;
